import { render } from "./CardTwo.vue?vue&type=template&id=327e8d98"
import script from "./CardTwo.vue?vue&type=script&lang=js"
export * from "./CardTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__